import styled from "@emotion/styled";

export const LogoBarContainer = styled("div")(() => ({
  display: "flex",
  justifyItems: "left",
  alignItems: "center",
  justifyContent: "space-between",
}));
